import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import store from "./store";
import "normalize.css";
import { ListView } from "@flowlist/vue-listview";
import { VAlert, VLazyload } from "@bilibili/sakura";

Vue.use(VueRouter);
Vue.use(VLazyload);
Vue.component(ListView.name, ListView);

Vue.config.productionTip = false;

Vue.prototype.$alert = VAlert();

const router = new VueRouter({
  mode: "history",
  routes: [],
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
